import { es } from 'date-fns/locale';
const locale = {
  localize: es.localize,
  options: {
    weekStartsOn: 0
  }
};
export default locale;